import {
  createSlice,
  createSelector,
  type PayloadAction,
} from '@reduxjs/toolkit';

import { RootState } from '../../store';

import { dynamicMenuApi } from './dynamicMenuApi';

import type { IAllMenu, MenuState } from './model';

const initialState: MenuState = {
  editingId: null,
  deleteConfirmation: {
    open: false,
    id: null,
    name: '',
  },
};

const dynamicMenuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setEditingId: (state, action: PayloadAction<number | null>) => {
      state.editingId = action.payload;
    },
    openDeleteConfirmation: (
      state,
      action: PayloadAction<{ id: number; name: string }>
    ) => {
      state.deleteConfirmation = {
        open: true,
        id: action.payload.id,
        name: action.payload.name,
      };
    },
    closeDeleteConfirmation: (state) => {
      state.deleteConfirmation = initialState.deleteConfirmation;
    },
  },
});

export const selectMenuById = createSelector(
  [
    (state: RootState) =>
      dynamicMenuApi.endpoints.dynamicMenuList.select()(state)?.data?.records,
    (_: RootState, id: number | null) => id,
  ],
  (menus, id) => {
    if (!menus || !id) {
      return null;
    }

    const findMenu = (menuList: IAllMenu[]): IAllMenu | null => {
      for (const menu of menuList) {
        if (menu.adminMenuId === id) {
          return menu;
        }
        if (menu.subMenu?.length) {
          const found = findMenu(menu.subMenu);
          if (found) {
            return found;
          }
        }
      }
      return null;
    };

    return findMenu(menus);
  }
);

export const { setEditingId, openDeleteConfirmation, closeDeleteConfirmation } =
  dynamicMenuSlice.actions;

export default dynamicMenuSlice;
